export class Permission {
    id = null;
    name = null;
    code = null;
    description = null;
}

export class RolePermission {
    permission = []
}